// extracted by mini-css-extract-plugin
export default {"ClientDetail":"TaskList_ClientDetail__vM26D","tableResponsive":"TaskList_tableResponsive__U-45H"};